<template>
  <section class="solutions-chapter-3">
    <div class="solutions-chapter-3-content">
      <SolutionsAnchorNav :section="3" />

      <v-container  class="px-sm-8 py-0 pa-md-0">
        <div v-for="n in coreprinciples" :key="n.title" class="solutions-chapter-3-content-card mb-12 mb-md-16">

          <div class="solutions-chapter-3-content-card-title mb-4 mb-md-8">
            <p class="text-section text--fes-magenta mb-0 mr-3">{{ n.title }}</p>            
            <hr class="hidden-sm-and-down">            
            <img :src="require('@/assets/solutions/solutions-ch2-' + `${n.icon}` + '.svg')" />
          </div>          

          <v-row no-gutters>
            <v-col cols="12" md="8" offset-md="4">
              <p class="text-body mb-6 text--fes-blue">{{ n.heading }}</p>
              <p class="text-body mb-0 text--fes-blue">{{ n.desc1 }}</p>
            </v-col>
          </v-row>
        </div>       
      </v-container>
    </div>
    
    <div class="solutions-chapter-3-hero">
      <img src="@/assets/solutions/solutions-ch3-banner.png" width="100%" />
    </div>       
  </section>  
</template>

<script>
import SolutionsAnchorNav from '@/components/layout/SolutionsAnchorNav'

export default {
  name: 'SolutionsChapter2',
  components: {
    SolutionsAnchorNav
  },  
  data() {
    return {
      coreprinciples: [
        { 
          icon: 'people',
          title: "Transformative pathways that care", 
          heading: "Social-ecological transformation cares about specific places and people. Its approach to change bridges the gap between local context—whether ecological, cultural, demographic, or infrastructural—and universal theories, values and guidelines. It uses systems thinking to understand the wide-ranging effects of any policy. Not doing so means solutions cost more, and can even cost lives.", 
          desc1: "In Navi Mumbai, clean technology company MinusCO2 installs rooftop solar power plants in residences and industrial premises. Customers pay per use at a rate 30–60 percent cheaper than existing power rates, making solar power easier to adopt. These plants cost a lot to set up and maintain, so MinusCO2 owns and manages them at no additional cost over a decade, then transfers them for free to customers. Though climate investing is often restricted to institutions, the scheme involves private and retail investors, with returns of around 14–15 percent.", 
        },
        { 
          icon: 'climate-justice',
          title: "Climate and social justice at all levels", 
          heading: "From national governments and international commitments to municipal authorities, we need to place both climate and social concerns at the heart of sustainable development. Only by leaving no one behind can the transition to a low-carbon city be a just one. Committing to climate protection plans and drastic cuts to CO2 emissions demands political commitment as well as social acceptance. Within the framework of a social-ecological transformation, the state must intervene more directly. Changes in consumer behaviour alone are not enough. Necessary change will succeed only when we combine regulatory with socially just measures, which incentivise climate-friendly behaviour.", 
          desc1: "The Climate Change Act of 2009 made good on these principles in the Philippines. The Act required local government units to work closely with barangays (villages) on prioritising climate change issues and solutions, with transparent communication and collaboration among local governments and with the national government. It recognised the poor, women and children as vulnerable populations, and emphasised involving a diverse range of stakeholders.",
        },
        { 
          icon: 'equal-rights',
          title: "Equal rights and participation for all", 
          heading: "The voice of every citizen deserves to be heard in the policymaking process. Governments need to involve people and experiences on the ground. Women and girls, especially, must be included in climate policies as equal partners and agents of change. Governments can ensure freedom of and access to information, and remove barriers to participation using digital technologies. Encouraging spaces for community participation, such as strengthening existing citizen movements and online advocacy, can empower communities to lead their own initiatives.", 
          desc1: "In India, Safai Bank of India turns collecting and processing multi-layered plastics (MLPs) into a banking system, drawing people into the circular economy. School-going children, especially, learn about waste materials and material chemistry; they take to it fast, changing their consumption habits when they realise how much waste they produce. By adding the collected and shredded MLPs to coal, which is then used as fuel, Safai Bank helps in avoiding the release of toxic dioxins and reducing coal usage in cement factories.", 
        },                                                        
      ]
    };
  },
}
</script>

<style lang="scss" scoped>
.solutions-chapter-3 {
  scroll-margin-top: 70px;
}

.solutions-chapter-3-content {
  padding: 96px 0;
  background: linear-gradient(180deg, #C9D4EC 0%, #ECF5F9 100%);

  .solutions-chapter-3-content-card:last-child {
    margin-bottom: unset !important;
  }

  .solutions-chapter-3-content-card-title {
    display: flex;
    align-items: center;

    hr {
      flex: 1;
      border-color: transparent;
      border-top: 1px dashed #8997C8;
      background-color: transparent;
      color: transparent;
    }

    img {
      vertical-align: middle;
    }
  }
}

.solutions-chapter-3-hero {
  img {
    display: block;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
.solutions-chapter-3-content {
  padding: 48px 4px;

  .solutions-chapter-3-content-card-title {
    align-items: center;
    justify-content: space-between;

    p {
      display: block;
      width: 66%;
    }

    img {
      width: 56px;
    }
  }
}  

}
</style>